// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2u0P_","range":"MonthRangeSwitch_range__6CPI8","disabled":"MonthRangeSwitch_disabled__3Cqr8"};